import { useState, useEffect } from 'react';
import {
  Box,
  IconButton,
  Typography,
  Tabs,
  Tab,
  Button,
  Modal,
  TextField,
  CircularProgress,
  Alert,
} from '@mui/material';
import {
  Terminal,
  WhatsApp,
  ArrowBack,
  ElectricBolt,
  Message,
  AccountTree,
  Splitscreen,
  FormatListBulleted,
  PlayCircleOutlined,
  ArrowCircleRightOutlined,
  StopCircle,
  AutoAwesome,
  Polyline,
  Storage,
  Image as ImageIcon,
  Description as DescriptionIcon,
  CloudUpload as CloudUploadIcon,
  Inbox as InboxIcon,
  SupportAgent as SupportAgentIcon,
} from '@mui/icons-material';
import { GetListMessages } from '../../Redux/MessageDucks'
import { generateFlowFromPrompt } from '../../Redux/FlowDucks'
import { useDispatch, useSelector } from 'react-redux'


function TabPanel(props) {
  const { children, value, index, ...other } = props;
  

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

export function FlowActions({ selectedFlow, setShowFlowList, handleOnCompile, onGenerateFlow }) {
  const [tabValue, setTabValue] = useState(0);
  const [messages, setMessage] = useState([]);

  // Generación de flujo con IA
  const [genOpen, setGenOpen] = useState(false);
  const [genPrompt, setGenPrompt] = useState('');
  const [genLoading, setGenLoading] = useState(false);
  const [genError, setGenError] = useState(null);

  const dispatch = useDispatch()
  const messageList = useSelector(store => store.message.messages)
  //const actionList = useSelector(store => store.message.messages)

  const fetchMessages = async () => {
    dispatch(GetListMessages(selectedFlow.businessLineId));
    
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  useEffect(() => {
    setMessage(messageList.list);
  }, [messageList]);


  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleGenerate = async () => {
    if (!genPrompt.trim()) return;
    setGenLoading(true);
    setGenError(null);
    try {
      const result = await dispatch(
        generateFlowFromPrompt(genPrompt.trim(), selectedFlow?.businessLineId)
      );
      const flowData = JSON.parse(result.content);
      if (onGenerateFlow) onGenerateFlow(flowData, result.warnings || []);
      setGenOpen(false);
      setGenPrompt('');
    } catch (err) {
      console.error('Error generando flujo:', err);
      setGenError(
        err?.response?.data?.error ||
        'No se pudo generar el flujo. Revisa el prompt e intenta de nuevo.'
      );
    } finally {
      setGenLoading(false);
    }
  };

  useEffect(() => {
    if (messageList && messageList.list){
      const newMessages = messageList.list.map((message) => {
        // IDs según tabla ResponsesTypes: 1=text, 4=list, 5=buttons.
        let icon;
        switch (message.responseType) {
          case 1:
            icon = <Message fontSize="small" />;
            break;
          case 5:
            icon = <Splitscreen fontSize="small" />;
            break;
          case 4:
            icon = <FormatListBulleted fontSize="small" />;
            break;
          default:
            icon = <Message fontSize="small" />;
        }

        const typeName =
          message.responseType === 1 ? "message" :
          message.responseType === 5 ? "button" :
          message.responseType === 4 ? "list" :
          "message";

        return {
          icon: icon,
          type: typeName,
          title: message.name,
          description: message.message,
          options: message.responseType === 4
            ? (() => { try { return JSON.parse(message.expected); } catch (e) { return []; } })()
            : [],
          expected: message.responseType === 1 ? message.expected : ""
        };
      });

      setMessage(newMessages);
    }

  }, [messageList]);


  const actionsContent = [
    {
      icon: <ElectricBolt fontSize="small" />,
      type: "event",
      title: 'Evento',
      description: 'Envia un evento para integrar',
    },
    {
      icon: <AccountTree fontSize="small" />,
      type: "condition",
      title: 'Condicion',
      description: 'Acción de Condición de lógica ',
    },
    {
      icon: <WhatsApp fontSize="small" />,
      type: "wsp",
      title: 'Componente WhatsApp',
      description: 'Componente para objetos complejos de WhatsApp',
    },
    {
      icon: <AutoAwesome fontSize="small" />,
      type: "agent",
      title: 'Agente I.A.',
      description: 'Componente de Integración I.A. con ChatGPT',
      data: {
        model: 'gpt-5.4',
        instructions: '',
        includeChatHistory: false,
        reasoningEffort: 'medium',
        expected: '',
      }
    },
    {
      icon: <Storage fontSize="small" />,
      type: "apicall",
      title: 'LLamada a API',
      description: 'Llamada a API con parametros para entregar contexto',
      data: {
        url: '',
        method: 'GET',
        queryParams: [{ key: '', value: '' }],
        headers: [{ key: '', value: '' }],
        APIBody: '',
        OutputKey: 'context',
        expectMultiple: false,
      },
    },
    {
      icon: <ImageIcon fontSize="small" />,
      type: "mediamessage",
      title: 'Mensaje multimedia',
      description: 'Envía una imagen, video o documento con caption',
      data: {
        mediaType: 'image',
        caption: '',
        fileName: '',
        mediaId: '',
      },
    },
    {
      icon: <PlayCircleOutlined fontSize="small" />,
      type: "start",
      title: 'Inicio',
      options: [],
      description: 'Marca para iniciar el flujo',
    },
    {
      icon: <ArrowCircleRightOutlined fontSize="small" />,
      type: "middle",
      title: 'Intermedio',
      options: [],
      description: 'Marca para continuar el flujo',
    },
    {
      icon: <StopCircle fontSize="small" />,
      type: "end",
      title: 'Termino',
      description: 'Marca para finalizar el flujo',
    },
    {
      icon: <PlayCircleOutlined fontSize="small" />,
      type: "campaign",
      title: 'Inicio por Campaña',
      options: [],
      description: 'Marca para iniciar el flujo por campaña',
    },
    {
      icon: <Polyline fontSize="small" />,
      type: "flow",
      title: 'Cambio de flujo',
      description: 'Cambio de flujo seleccionable',
    },
    {
      icon: <WhatsApp fontSize="small" />,
      type: "wsp_flow",
      title: 'WhatsApp Flow',
      description: 'Template (Meta) que solicita datos al usuario y abre un WhatsApp Flow',
      data: {
        accountId: '',
        whatsappFlowId: '',
        whatsappFlowCta: 'Abrir',
        whatsappFlowStartScreen: '',
        whatsappFlowPrefillKeys: [],
        bodyText: 'Completa el formulario',
        footerText: '',
        whatsappFlowName: '',
      },
    },
    {
      icon: <DescriptionIcon fontSize="small" />,
      type: "document_pdf",
      title: 'Documento PDF',
      description: 'Genera un PDF desde HTML template y lo guarda en base64',
      data: {
        BodyText: '',
        APIBody: '',
        Params: [],
        OutputKey: '',
      },
    },
    {
      icon: <CloudUploadIcon fontSize="small" />,
      type: "media_upload",
      title: 'Media Upload',
      description: 'Sube un archivo a WhatsApp (Graph) desde Base64 usando el backend',
      data: {
        AccountId: '',
        InputVarKey: '',
        PersistInputVarKey: '',
        MediaType: 'application/pdf',
        Filename: '',
        OutputKey: '',
      },
    },
    {
      icon: <InboxIcon fontSize="small" />,
      type: "document_inbox",
      title: 'Bandeja de documentos',
      description: 'Espera attachments del cliente. El agente IA valida y avanza al recibir todos los docs requeridos.',
      data: {
        label: 'Bandeja de documentos',
        description: 'Recibe los documentos del cliente, los valida con el agente IA y avanza cuando todos están aprobados.',
      },
    },
    {
      icon: <SupportAgentIcon fontSize="small" />,
      type: "enqueue_human",
      title: 'Cola de Espera',
      description: 'Encola la conversación en la cola de espera para atención humana',
      data: {
        notes: '',
        priority: 'normal',
      },
    },
  ];

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <IconButton size="small" onClick={() => setShowFlowList(true)}>
          <ArrowBack />
        </IconButton>
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            {selectedFlow ? selectedFlow.name : 'Your automation pipeline'}
          </Typography>
        </Box>
      </Box>
      <Tabs value={tabValue} onChange={handleTabChange} sx={{ mb: 2 }}>
        <Tab label="Messages" id="tab-0" aria-controls="tabpanel-0" />
        <Tab label="Actions" id="tab-1" aria-controls="tabpanel-1" />
      </Tabs>
      <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
        <TabPanel value={tabValue} index={0}>
          {messages.map((item, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                p: 1,
                borderRadius: 1,
                cursor: 'pointer',
                '&:hover': { bgcolor: 'action.hover' },
              }}
              draggable
              onDragStart={(event) => {
                const dragData = {
                    type: item.type,
                    data: {
                      label: item.title,
                      description: item.description,
                      connectedHandles: []
                    }
                    // Puedes incluir otras propiedades serializables si es necesario
                  };

                if (item.type === "list") {
                  
                  if (Array.isArray(item.options)) {
                    var optionList = []
                    item.options.forEach((option, index) => {
                      optionList.push({title:option, id:`option-${index}`})
                    });

                    dragData.data.options = optionList

                  }
                
                } else if (item.type === "message") {
                  dragData.data.expected = item.expected;
                }
                event.dataTransfer.setData('application/reactflow', JSON.stringify(dragData));
                event.dataTransfer.effectAllowed = 'move';
              }}
            >
              {item.icon}
              <Box>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {item.title}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{
                  display: '-webkit-box',
                  overflow: 'hidden',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 3,
                }}>
                  {item.description}
                </Typography>
              </Box>
            </Box>
          ))}
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          {actionsContent.map((item, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                p: 1,
                borderRadius: 1,
                cursor: 'pointer',
                '&:hover': { bgcolor: 'action.hover' },
              }}
              draggable
              onDragStart={(event) => {
                const dragData = {
                    //icon: item.icon,
                    type: item.type,
                    data: {
                      label: item.title,
                      description: item.description,
                      connectedHandles: [],
                      ...(item.data || {}),
                    }
                    // Puedes incluir otras propiedades serializables si es necesario
                  };

                if (item.type === "campaign") {
                  var optionList = []
                 
                  if (Array.isArray(item.options) && item.options.length > 0) {
                    item.options.forEach((option, index) => {
                      optionList.push({title: option, id: `option-${index}`});
                    });
                  } 
                  else {
                    // ← Opción inicial obligatoria
                    optionList.push({title: 'Nueva opción', id: 'option-0'});
                  }

                  dragData.data.options = optionList

                }
                event.dataTransfer.setData('application/reactflow', JSON.stringify(dragData));
                event.dataTransfer.effectAllowed = 'move';
              }}
            >
              {item.icon}
              <Box>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {item.title}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {item.description}
                </Typography>
              </Box>
            </Box>
          ))}
        </TabPanel>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt:"8px" }}>
        <Button
          variant="outlined"
          sx={{ width:"100%", p: 1 }}
          startIcon={<AutoAwesome />}
          onClick={() => { setGenError(null); setGenOpen(true); }}
        >
          Generar con IA
        </Button>
        <Button
          variant="contained"
          sx={{ width:"100%", p: 1 }}
          onClick={() => handleOnCompile()}
        >
          <Terminal /> Compilar
        </Button>
      </Box>

      <Modal open={genOpen} onClose={() => !genLoading && setGenOpen(false)}>
        <Box sx={{
          position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
          width: 520, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, p: 3,
        }}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
            Generar flujo con IA
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Describe el flujo en lenguaje natural. La IA generará un borrador editable que reemplazará el lienzo actual; podrás ajustarlo y guardarlo.
          </Typography>
          {genError && <Alert severity="error" sx={{ mb: 2 }}>{genError}</Alert>}
          <TextField
            label="Describe el flujo"
            placeholder="Ej: Saluda, pide el nombre, pregunta con botones si es cliente nuevo o existente; si es nuevo deriva a un agente IA, si es existente termina."
            multiline
            minRows={4}
            fullWidth
            value={genPrompt}
            onChange={(e) => setGenPrompt(e.target.value)}
            disabled={genLoading}
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
            <Button onClick={() => setGenOpen(false)} disabled={genLoading}>Cancelar</Button>
            <Button
              variant="contained"
              onClick={handleGenerate}
              disabled={genLoading || !genPrompt.trim()}
              startIcon={genLoading ? <CircularProgress size={16} color="inherit" /> : <AutoAwesome />}
            >
              {genLoading ? 'Generando…' : 'Generar'}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
